import dayjs from "dayjs";

//let lastDisplayedDate = null;
const batteryOption = {
  dataZoom: [
    {
      type: "slider",
      start: 0,
      end: 100,
      show: true,
      showDetail: false,
    },
  ],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  grid: {
    left: 60,
    top: 20,
    right: 20,
    bottom: 100,
  },
  xAxis: [
    {
      type: "category",
      name: "Time",
      boundaryGap: true,
      nameGap: 40,
      nameLocation: "middle",
      axisPointer: {
        label: {
          formatter: function (params) {
            return dayjs(params.value).format("MM-DD-YYYY HH:mm:ss");
          },
        },
        handle: {
          show: false,
        },
      },
      axisLabel: {
        hideOverlap: true,
        formatter: function (value) {
          const date = new Date(value);
          const formattedDate = `${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${date
            .getDate()
            .toString()
            .padStart(2, "0")}/${date.getFullYear()}`;
          // if (formattedDate === lastDisplayedDate) {
          //   return "";
          // }
          // lastDisplayedDate = formattedDate;
          return formattedDate;
        },
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "Percentage (%)",
      nameGap: 40,
      nameRotate: 90,
      nameLocation: "middle",
    },
  ],
  series: [
    {
      name: "Battery Level",
      data: [],
      type: "bar",
    },
  ],
};

export default batteryOption;
